export const cdnImage = (string: string): string =>
  `https://cdn.canopytax.com/images/${string}`;
